import { Deserializable } from "../shared/models/deserializable.model";
import { GalleryPhoto } from "./gallery-photo";

export class Gallery implements Deserializable {
  id: string;
  name: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
  GalleryPhotos: GalleryPhoto[];
  isGeneralGallery: boolean;
  contactId?: number;

  constructor() {
    this.GalleryPhotos = [];
    this.isGeneralGallery = false;
  }

  deserialize(input: any) {
    Object.assign(this, input);

    // Map GalleryPhotos array if it exists
    if (input.GalleryPhotos && input.GalleryPhotos.length > 0) {
      this.GalleryPhotos = input.GalleryPhotos.map(photo => new GalleryPhoto().deserialize(photo));
    } else {
      this.GalleryPhotos = [];
    }

    // Map dates
    if (input.createdAt) {
      this.createdAt = new Date(Date.parse(input.createdAt));
    }
    if (input.updatedAt) {
      this.updatedAt = new Date(Date.parse(input.updatedAt));
    }

    // Set default value for isGeneralGallery if not provided
    if (input.isGeneralGallery === undefined) {
      this.isGeneralGallery = false;
    }

    return this;
  }
} 